import { Injectable, OnDestroy } from '@angular/core';
import { AbstractPolyShapeService } from '../abstract-polyshape.service';
import { PolygonHelper } from './polygon-helper';

@Injectable()
export class PolygonService
  extends AbstractPolyShapeService<PolygonHelper>
  implements OnDestroy
{
  protected shapeStore = this.renderStore('polygons');

  constructor() {
    super();
    this.setUpSubscriptions();
  }

  protected createHelper(index: number) {
    return new PolygonHelper(index);
  }
}
